const $ = window.jQuery;

$(function () {
	let moreBtn = $(".header .more-trigger, .header .close-more-menu, .header .burger");

	moreBtn.on("click", function (e) {
		e.preventDefault();
		$("body, html").toggleClass("js-more-menu-open");
	});
	
	// $(".more-nav .menu-item a").on("click", function () {
	// 	$("body, html").toggleClass("js-more-menu-open");
	// });

	$(".nav-more .menu-item a").on("click", function () {
		console.log('here');
		$("body, html").toggleClass("js-more-menu-open");
	});
});
